export interface ShowFillsToggleProps {
  showFills: boolean;
  onChange: (next: boolean) => void;
}

/**
 * Props-driven checkbox toggling between consolidated leg rows (default) and
 * raw per-fill rows. State ownership lives in `useShowFills` -- this
 * component just renders it. Wrapping the input in a `<label>` gives the
 * checkbox its accessible name ("Show fills") with no extra `aria-label`.
 */
export function ShowFillsToggle({ showFills, onChange }: ShowFillsToggleProps) {
  return (
    <label className="flex items-center gap-1.5 text-xs text-gray-500 cursor-pointer select-none">
      <input
        type="checkbox"
        checked={showFills}
        onChange={(e) => onChange(e.target.checked)}
        className="h-3.5 w-3.5 rounded border-gray-300 text-brand-600 focus:ring-brand-500"
      />
      Show fills
    </label>
  );
}
